// extracted by mini-css-extract-plugin
export default {"popupContainer":"welcome-popup_popupContainer__8Q4Z1"};